module.exports = __webpack_public_path__ + "media/images/mailer/group-48-primary-334ce407279f0cb5067865c3fd2e4d6f.png";